import React from "react";
import { Tooltip } from "@material-ui/core";

export const changeValueText = (value) => Array.isArray(value) ? value.join(", ") :
  value == null || value === "" ? "–" : value === true ? "Ja" : value === false ? "Nein" : String(value);

export default function ChangedValue({ previousValue, currentValue, label, children }) {
  if (previousValue === undefined) return <>{children}</>;
  const message = `${label}: ursprünglich ${previousValue}; aktuell ${changeValueText(currentValue)}`;
  return <Tooltip arrow enterTouchDelay={0} title={<>
    <strong>{label}</strong><br />Ursprünglicher Wert: {previousValue}<br />Aktueller Wert: {changeValueText(currentValue)}
  </>}>
    <span tabIndex={0} aria-label={message} style={{ display: "inline-block" }}>{children}</span>
  </Tooltip>;
}
